export const isUserLogin = ({ auth }) => auth.isLogin;
export const getUser = ({ auth }) => auth.userData;
